module.exports = __webpack_public_path__ + "img/svg/referee.08f92838d7235a450b1b4b60fd1026c6.svg";